import React from "react";
import { OnboardingPage } from "../../../layouts/OnboardingPage";
import RegisterForm from "./RegisterForm";
import useProfileInfo from "./useProfileInfo";
import useAuthState from "../../../hooks/useAuthState";
import { Button } from "@blueprintjs/core";
import { useHistory } from "react-router-dom";

import styles from "./RegisterForm.module.scss";

function ProfileInfo() {
  const profileInfoProps = useProfileInfo();
  const history = useHistory();
  const { isLoggedIn, logout } = useAuthState();

  return (
    <>
      <OnboardingPage title="Create an Account">
        {isLoggedIn && (
          <Button className={styles.btnLogout} onClick={logout}>Sign Out</Button>
        )}
        <RegisterForm
          {...profileInfoProps}
        />
        {!isLoggedIn && (
          <div className={styles.loginText} onClick={() => history.push("/login")}>
            Already have an account? <span className={styles.signInText}>Sign in</span>
          </div>
        )}
      </OnboardingPage>
    </>
  );
}

export default ProfileInfo;
